import { SxProps, Theme, Typography } from "@mui/material";
import theme from "assets/styles/themes";

const colorConfig = {
    primary: {
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.neutrals.dark}`,
    },
    secondary: {
        color: theme.palette.common.white,
        border: `1px solid ${theme.palette.common.white}`,
    },
};

const TagName = ({
    children,
    color = "primary",
    ...sx
}: {
    children: string;
    color?: "primary" | "secondary";
    sx?: SxProps<Theme>;
}) => {
    return (
        <Typography
            sx={(theme) => ({
                fontSize: 16,
                display: "inline-block",
                padding: theme.spacing(0.25, 1),
                borderRadius: theme.spacing(1),
                ...colorConfig[color],
                ...sx,
            })}
        >
            {children}
        </Typography>
    );
};

export default TagName;
